var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.942 64a1 1 0 0 1 .058.058v383.885a1 1 0 0 1-.058.058H32.057a.5.5 0 0 1-.057-.058V64.057a1 1 0 0 1 .057-.057zM480 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h448c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416 144c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48M448 416H64v-64l112-192 128 160h32l112-96z"
  })));
};
export default SvgImage;